import { render, staticRenderFns } from "./otherBind.vue?vue&type=template&id=0526276a"
import script from "./otherBind.vue?vue&type=script&lang=js"
export * from "./otherBind.vue?vue&type=script&lang=js"
import style0 from "./otherBind.vue?vue&type=style&index=0&id=0526276a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports